// ============================================
// INFRASTRUCTURE - Session Repository
// ============================================

import type { SessionData } from '../../domain/entities';
import { axiosClient } from './axios-client';

export const sessionRepository = {
  /**
   * Obtiene el estado global del usuario y almacén
   */
  async getSession(): Promise<SessionData> {
    const { data } = await axiosClient.get<SessionData>('/app/session');
    return data;
  },

  /**
   * Envía heartbeat para registrar actividad del usuario
   * Se ejecuta una vez al día para verificar que el usuario está activo
   */
  async sendHeartbeat(): Promise<void> {
    await axiosClient.post('/app/session/heartbeat');
  },
};
